import {h} from 'ui/Framework';

export default h('svg', {
  width: '72',
  height: '54',
  viewBox: '-1 -1 74 56',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', [
      h('g', [
        h('path', {
          stroke: '#9FAAC0',
          d: 'M0 0h72v16H0z'
        }),
        h('path', {
          fill: '#D6DCE4',
          d: 'M0 20h72v34H0z'
        }),
        h('path', {
          d: 'M31 43V32l11 5.5L31 43z',
          fill: '#FFF'
        }),
        h('path', {
          d: 'M5.458 6.981a1.27 1.27 0 0 1 .567-.585 1.74 1.74 0 0 1 .846-.216c.534 0 .934.159 1.201.477.268.318.401.738.401 1.26V10.5h-.612V8.169c0-.222-.018-.423-.054-.603a1.262 1.262 0 0 0-.185-.463.882.882 0 0 0-.35-.302 1.255 1.255 0 0 0-.554-.108 1.16 1.16 0 0 0-.882.4c-.12.136-.216.306-.288.513a2.236 2.236 0 0 0-.108.734v2.16h-.612V3.696h.612v3.285h.018zm6.498-.18h-1.188v2.457c0 .156.015.285.045.387a.55.55 0 0 0 .13.239.445.445 0 0 0 .203.117.966.966 0 0 0 .252.031c.084 0 .172-.012.266-.036.093-.024.181-.057.265-.099l.027.531c-.108.042-.22.073-.338.095a2.169 2.169 0 0 1-.382.031c-.114 0-.234-.015-.36-.045a.91.91 0 0 1-.617-.513 1.32 1.32 0 0 1-.103-.567V6.801h-.873v-.513h.873V5.1h.612v1.188h1.188v.513zm2.745 0h-1.188v2.457c0 .156.015.285.045.387a.55.55 0 0 0 .13.239.445.445 0 0 0 .203.117.966.966 0 0 0 .252.031c.084 0 .172-.012.265-.036.094-.024.182-.057.266-.099l.027.531c-.108.042-.22.073-.338.095a2.169 2.169 0 0 1-.382.031c-.114 0-.234-.015-.36-.045a.91.91 0 0 1-.617-.513 1.32 1.32 0 0 1-.103-.567V6.801h-.873v-.513h.873V5.1h.612v1.188h1.188v.513zm1.566 5.859h-.612V6.288h.612v.729h.027c.174-.276.406-.484.697-.626.292-.14.587-.211.887-.211.33 0 .628.057.895.171a2.04 2.04 0 0 1 1.125 1.17c.106.27.158.561.158.873 0 .312-.052.603-.158.873-.105.27-.251.504-.44.702a2.04 2.04 0 0 1-.684.468 2.259 2.259 0 0 1-.896.171c-.3 0-.595-.07-.887-.212a1.713 1.713 0 0 1-.697-.607h-.027v2.871zm3.141-4.266a2 2 0 0 0-.108-.662 1.601 1.601 0 0 0-.31-.54 1.464 1.464 0 0 0-.5-.364 1.614 1.614 0 0 0-.675-.135 1.555 1.555 0 0 0-1.161.49 1.663 1.663 0 0 0-.337.54c-.082.208-.122.431-.122.671 0 .24.04.463.122.67.08.208.193.386.337.536a1.588 1.588 0 0 0 1.161.486c.252 0 .477-.043.675-.13.198-.088.364-.207.5-.36.135-.154.238-.333.31-.54a2 2 0 0 0 .108-.662zm2.988-1.674a.488.488 0 0 1-.135.338.452.452 0 0 1-.351.148.452.452 0 0 1-.351-.149.488.488 0 0 1 0-.675.452.452 0 0 1 .351-.148.488.488 0 0 1 .486.486zm0 3.348a.488.488 0 0 1-.135.338.452.452 0 0 1-.351.148.452.452 0 0 1-.351-.149.488.488 0 0 1 0-.675.452.452 0 0 1 .351-.148c.144 0 .261.05.351.148.09.1.135.212.135.338zm1.431.594l-.522-.171 2.727-6.525.513.18-2.718 6.516zm3.33 0l-.522-.171 2.727-6.525.513.18-2.718 6.516z',
          fill: '#A3A9B2'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/preview-widget.es6.js